module.exports = __webpack_public_path__ + "static/media/9S.6318c689.svg";